__turbopack_context__.v({
  "actionBtn": "alerts-module-scss-module__lbo4Zq__actionBtn",
  "alert": "alerts-module-scss-module__lbo4Zq__alert",
  "alert-enter": "alerts-module-scss-module__lbo4Zq__alert-enter",
  "alert-enter-active": "alerts-module-scss-module__lbo4Zq__alert-enter-active",
  "alert-exit-active": "alerts-module-scss-module__lbo4Zq__alert-exit-active",
  "body": "alerts-module-scss-module__lbo4Zq__body",
  "bottomCenter": "alerts-module-scss-module__lbo4Zq__bottomCenter",
  "bottomLeft": "alerts-module-scss-module__lbo4Zq__bottomLeft",
  "bottomRight": "alerts-module-scss-module__lbo4Zq__bottomRight",
  "bounce": "alerts-module-scss-module__lbo4Zq__bounce",
  "closeBtn": "alerts-module-scss-module__lbo4Zq__closeBtn",
  "closeIcon": "alerts-module-scss-module__lbo4Zq__closeIcon",
  "container": "alerts-module-scss-module__lbo4Zq__container",
  "content": "alerts-module-scss-module__lbo4Zq__content",
  "error": "alerts-module-scss-module__lbo4Zq__error",
  "hasExtras": "alerts-module-scss-module__lbo4Zq__hasExtras",
  "icon": "alerts-module-scss-module__lbo4Zq__icon",
  "info": "alerts-module-scss-module__lbo4Zq__info",
  "message": "alerts-module-scss-module__lbo4Zq__message",
  "spinner": "alerts-module-scss-module__lbo4Zq__spinner",
  "success": "alerts-module-scss-module__lbo4Zq__success",
  "title": "alerts-module-scss-module__lbo4Zq__title",
  "topCenter": "alerts-module-scss-module__lbo4Zq__topCenter",
  "topLeft": "alerts-module-scss-module__lbo4Zq__topLeft",
  "topRight": "alerts-module-scss-module__lbo4Zq__topRight",
  "warning": "alerts-module-scss-module__lbo4Zq__warning",
  "wrp": "alerts-module-scss-module__lbo4Zq__wrp",
});
